import React from "react"
import { Box, Container, Flex } from "@chakra-ui/react"

import { SectionProps, withSection } from "@app/hoc/Section"
import FeaturedLearnItem from "./FeaturedLearnItem"

export type FeaturedLearnProps = GatsbyTypes.SanitySectionFeaturedLearn & SectionProps

const FeaturedLearn = ({ learnPages, theme, innerRef, handleTrackingClick }: FeaturedLearnProps) => (
  <Box id={`featured-learn`} my={6} py={6} ref={innerRef} as="section" backgroundColor={theme === "Dark" ? "brand.beige.dark" : "white"}>
    <Container>
      <Flex rowGap={4} columnGap={2} flexWrap={`wrap`} justifyContent={{ md: `center` }}>
        {learnPages?.map(item => (
          <Box
            key={item?._key}
            minWidth={{ base: `100%`, md: `calc((100% / 3) - var(--chakra-space-4))` }}
            width={{ base: `100%`, md: `calc((100% / 3) - var(--chakra-space-4))` }}
          >
            <FeaturedLearnItem item={item} handleTrackingClick={handleTrackingClick} />
          </Box>
        ))}
      </Flex>
    </Container>
  </Box>
)

export default React.memo(withSection(FeaturedLearn))
